import { render } from "./Eula.vue?vue&type=template&id=85c46f6e&scoped=true"
import script from "./Eula.vue?vue&type=script&lang=js"
export * from "./Eula.vue?vue&type=script&lang=js"

import "./Eula.vue?vue&type=style&index=0&id=85c46f6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c46f6e"]])

export default __exports__